import React, { Component } from 'react';

import Regua from '../../components/Regua/Regua';
import Footer from '../../components/Footer/Footer';
import LegacyMode from '../../components/LegacyMode/LegacyMode';

class LayoutPublic extends Component {
  render() {
    return (
      <>
        <LegacyMode />
        <div>
          {this.props.children}
        </div>
        <Regua open={false} />
        <Footer open={false} />
      </>
    );
  }
}

export default LayoutPublic;